import { render } from "./MyinvHeader.vue?vue&type=template&id=35f1af48&scoped=true&ts=true"
import script from "./MyinvHeader.vue?vue&type=script&lang=ts"
export * from "./MyinvHeader.vue?vue&type=script&lang=ts"

import "./MyinvHeader.vue?vue&type=style&index=0&id=35f1af48&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f1af48"]])

export default __exports__